export default "__VITE_ASSET__CC34Ah$D__"